import React, { useEffect, useRef, useState } from 'react';
import styles from './ProfilCard.module.css';
import ProfilHeader from './ProfilHeader';
import AvatarFields from '../ui/AvatarFields/AvatarFields';
import { getProfil, putProfil } from "../../api/User/profil";
import { useNavigate } from 'react-router-dom';

const subtitleRole = {
    trader: 'Commerçant',
    client: 'Client',
    admin: 'Administrateur',
}

const ProfilCard = () => {
    const [idUser, setIdUser] = useState('');
    const [firstname, setFirstname] = useState('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [number, setNumber] = useState('');
    const [traderCode, setTraderCode] = useState('');
    const [role, setRole] = useState('')
    const [error, setError] = useState(null);
    const [category, setCategory] = useState('restaurants');
    const navigate = useNavigate();
    const paraRef = useRef(null);

    useEffect(() => {
        const fetchProfil = async () => {
            const result = await getProfil(navigate);
            const data = result.data;
            if (data) {
                setIdUser(`Identifiant : ${data.id}`);
                setFirstname(data.firstname);
                setName(data.name);
                setEmail(data.email);
                setNumber(data.number || '');
                setRole(data.role);
                if (data.traderCode) setTraderCode(data.traderCode);
                if (data.category) setCategory(data.category);
            }
        };
        fetchProfil();
    }, [navigate]);


    async function handleSubmit(e) {
        e.preventDefault();

        const data = await putProfil({ email, number, firstname, name, traderCode, role, category, navigate });
        if (data.success) {
            if (paraRef.current) paraRef.current.style.color = "green";
            setError(data.message);
        } else {
            if (paraRef.current) paraRef.current.style.color = "red";
            setError(data.error.message);
        }
    }

    return (
        <form onSubmit={handleSubmit} className={styles.layout}>
            <ProfilHeader firstname={firstname} role={subtitleRole[role]} category={category} setCategory={setCategory} />
            <div className={styles.profil}>
                <AvatarFields index='identifier' value={idUser} />
                <AvatarFields index='firstname' value={firstname} setValue={setFirstname} />
                <AvatarFields index='name' value={name} setValue={setName} />
                <AvatarFields index='email' value={email} setValue={setEmail} />
                <AvatarFields index='phone' value={number} setValue={setNumber} />
                {role === 'trader' && <AvatarFields index='traderCode' value={traderCode} setValue={setTraderCode} />}
            </div>
            <p ref={paraRef} className={styles.error}>{error}</p>
            <button className={styles.btn} type='sumbit'>Mettre à jour</button>
        </form>
    );
};

export default ProfilCard;